import {
  LayoutDashboard,
  Radar,
  Users,
  Car,
  Cpu,
  Route,
  Siren,
  Building2,
  Bell,
  BarChart3,
  ShieldCheck,
  Settings as SettingsIcon,
  ScrollText,
  ClipboardList,
  ListChecks,
  CheckCircle2,
  FileText,
  Ambulance,
  Flame,
  HeartPulse,
  BedDouble,
  UserCheck,
  Activity,
} from "lucide-react";

export const ROLE_META = {
  super_admin: {
    label: "Super Admin",
    title: "Master Control",
    badge: "Master",
    base: "/admin",
    className: "role-super-admin",
  },
  police: {
    label: "Police",
    title: "Police Command",
    badge: "Police",
    base: "/police",
    className: "role-police",
  },
  ambulance: {
    label: "Ambulance · 108",
    title: "108 Dispatch",
    badge: "108",
    base: "/ambulance",
    className: "role-ambulance",
  },
  fire: {
    label: "Fire Brigade",
    title: "Fire Command",
    badge: "Fire",
    base: "/fire",
    className: "role-fire",
  },
  hospital: {
    label: "Hospital",
    title: "Trauma & ER",
    badge: "Hospital",
    base: "/hospital",
    className: "role-hospital",
  },
};

export const SIDEBAR_NAV = {
  super_admin: [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/live", label: "Live Monitoring", icon: Radar, permission: "VEHICLES.READ" },
    { to: "/admin/incidents", label: "Incidents", icon: Siren, permission: "INCIDENTS.READ" },
    { to: "/admin/customers", label: "Customers", icon: ShieldCheck, permission: "USERS.READ" },
    { to: "/admin/vehicles", label: "Vehicles", icon: Car, permission: "VEHICLES.READ" },
    { to: "/admin/services", label: "Emergency Services", icon: Building2, permission: "ORGANIZATIONS.READ" },
    { to: "/admin/users", label: "System users", icon: Users, permission: "USERS.READ" },
    { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
    { to: "/admin/settings", label: "Settings", icon: SettingsIcon },
    { to: "/admin/security", label: "Security Logs", icon: ScrollText, permission: "AUDIT.READ" },
  ],
  police: [
    { to: "/police", label: "Dashboard", icon: LayoutDashboard, end: true, permission: "INCIDENTS.READ" },
    { to: "/police/alerts", label: "New Alerts", icon: Bell, permission: "INCIDENTS.READ" },
    { to: "/police/live-monitoring", label: "Live Monitoring", icon: Radar, permission: "TELEMETRY.READ" },
    { to: "/police/active", label: "Active Cases", icon: ListChecks, permission: "INCIDENTS.READ" },
    { to: "/police/completed", label: "Completed Cases", icon: CheckCircle2, permission: "INCIDENTS.READ" },
    { to: "/police/activities", label: "Vehicle Activities", icon: Activity },
    { to: "/police/reports", label: "Reports", icon: FileText },
    { to: "/police/service-provider-details", label: "System Users", icon: Building2, permission: "ORGANIZATIONS.READ" },
  ],
  ambulance: [
    { to: "/ambulance", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/ambulance/alerts", label: "Incoming Alerts", icon: Bell, permission: "INCIDENTS.READ" },
    { to: "/ambulance/active", label: "Active Trips", icon: Ambulance, permission: "TRIPS.READ" },
    { to: "/ambulance/completed", label: "Completed Trips", icon: CheckCircle2, permission: "TRIPS.READ" },
    { to: "/ambulance/service-provider-details", label: "System Users", icon: Building2, permission: "ORGANIZATIONS.READ" },
  ],
  fire: [
    { to: "/fire", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/fire/alerts", label: "New Alerts", icon: Bell, permission: "INCIDENTS.READ" },
    { to: "/fire/active", label: "Active Incidents", icon: Siren, permission: "INCIDENTS.READ" },
    { to: "/fire/reports", label: "Reports", icon: FileText },
    { to: "/fire/service-provider-details", label: "System Users", icon: Building2, permission: "ORGANIZATIONS.READ" },
  ],
  hospital: [
    { to: "/hospital", label: "Incoming Patients", icon: HeartPulse, end: true },
    { to: "/hospital/beds", label: "Bed Management", icon: BedDouble },
    { to: "/hospital/active", label: "Active Cases", icon: UserCheck },
    { to: "/hospital/service-provider-details", label: "System Users", icon: Building2 },
  ],
};

export const ROLE_KPI_TITLES = {
  super_admin: "All-system overview",
  police: "Patrol command",
  ambulance: "Dispatch desk",
  fire: "Brigade ops",
  hospital: "Trauma & ER",
};
